import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ApiService } from "../../Components/Services/apiservices";
import LightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

const apiServices = new ApiService();

function WeddingVenue() {
  const didMountRef = useRef(true);
  const { slug } = useParams();
  const [pageData, setPageData] = useState({});
  const [pageContent, setPageContent] = useState("");
  const [headerImage, setHeaderImage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    if (didMountRef.current) {
      const dataString = {
        page_url: "best-indian-restaurant-in-london",
      };

      apiServices.pagePostRequest(dataString).then((res) => {
        if (res.data.status === "success") {
          if (res.data.pageData != null) {
            setPageData(res.data.pageData);
            setPageContent(res.data.pageData.page_content);
            setHeaderImage(res.data.page_header_url);
          } else {
            navigate("/");
          }
        }
      });
    }

    didMountRef.current = false;
  }, []);

  // ✅ Initialize LightGallery AFTER content render
  useEffect(() => {
    if (pageContent) {
      setTimeout(() => {
        const elements = document.querySelectorAll(".lg-react-element");

        elements.forEach((el) => {
          if (!el.classList.contains("lg-initialized")) {
            LightGallery(el, {
              plugins: [lgThumbnail, lgZoom],
              selector: "a",
            });
          }
        });
      }, 500);
    }
  }, [pageContent]);

  return (
    <>
      <nav className="navbar navbar-expand-md">
        <div className="container">
          <div className="logo-wrapper mlogo">
            <a className="logo" href="/">
              {" "}
              <img
                src="/assets/img/Chokhi_Dhani.png"
                className="logo-img"
                alt=""
              />{" "}
            </a>
          </div>
         
          <div className="collapse navbar-collapse" id="navbar">
            <ul className="navbar-nav mx-auto">
              <div className="logo-wrapper mclogo">
                <a className="logo" href="/">
                  {" "}
                  <img
                    src="/assets/img/Chokhi_Dhani.png"
                    className="logo-img"
                    alt=""
                  />{" "}
                </a>
              </div>
            </ul>
          </div>
        </div>
      </nav>
      {/* Banner */}
      <div
        className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed"
        data-overlay-dark="3"
        style={{
          backgroundImage: `url(${
            pageData.page_header_image
              ? headerImage + pageData.page_header_image
              : ""
          })`,
          backgroundSize: "cover",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center caption mt-90">
              {pageData.page_sub_header && <h5>{pageData.page_sub_header}</h5>}
              {pageData.page_header && <h1>{pageData.page_header}</h1>}
            </div>
          </div>
        </div>
      </div>

      {/* Page Content */}
      {pageContent && (
        <div dangerouslySetInnerHTML={{ __html: pageContent }} />
      )}
      <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="footer-bottom-inner">
                  <p className="footer-bottom-copy-right">© Copyright 2023 by <a href="/">Chokhi Dhani. All rights reserved.</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
    </>
  );
}

export default WeddingVenue;